import React from 'react';
import DataTable from 'react-data-table-component';
import $ from 'jquery';

const countPerPage = 10;
let columns;
let tabcolumns;
let tabpagecolumns;
const arrowdown = (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        className="feather feather-arrow-up-circle"
    >
        <circle cx="12" cy="12" r="10" />
        <polyline points="16 12 12 8 8 12" />
        <line x1="12" y1="16" x2="12" y2="8" />
    </svg>
);
var tabData = [
    {name: 'Summary', isActive: true},
    {name: 'Return Reason', isActive: false},
    {name: 'Detail', isActive: false},
];
const inpersonateFlag = localStorage.getItem('inpersonate');

class SearchReports extends React.Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {
            query: '',
            results: {},
            meta: {},
            error: '',
            selectValue: true,
            searchRport: true,
            reportResults: {},
            is_export: 1,
            islistloading: false,
            is_email: 1,
            is_email_message: '',
            isemailloading: false,
            activeIndex: 0,
            report_tab_type: 'Summary',
            reporttab_index: 0,
            tab_reportResults: {},
            istab_active: false,
        };
        this.togglePanelSelectValue = this.togglePanelSelectValue.bind(this);
        this.togglePanelsearchReport = this.togglePanelsearchReport.bind(this);
    }

    togglePanelSelectValue(e) {
        this.setState({selectValue: !this.state.selectValue});
    }

    togglePanelsearchReport(e) {
        this.setState({searchRport: !this.state.searchRport});
        $('.report-actions').toggleClass('hide');
        if (this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report') {
            $('.report-actions').toggleClass('hide');
        }
    }

    exportFile = async e => {
        this.setState({islistloading: true});
        let offertypeVal = $('.hidden-lbl.offer-type').text();
        let mediumVal = $('.hidden-lbl.medium-lbl').text();
        const get_token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        let billingYearValue = this.props.searchresults.selectMonth.getFullYear();
        let billingMonthValue = ('0' + (this.props.searchresults.selectMonth.getMonth() + 1)).slice(
            -2
        );
        let objArr = {
            report_type: this.props.searchresults.selectedOption.value,
            present_date_range: this.props.searchresults.daterangeoption.value,
        };
        if (this.state.is_export == 1) {
            objArr = {...objArr, ['is_export']: this.state.is_export};
        }
        // if (inpersonateFlag == 'true'){
        //   objArr = {...objArr, ['view_user_id'] : userId }
        // }
        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' ||
            this.props.searchresults.selectedOption.value == 'unique_student_report'
        ) {
            objArr = {...objArr, ['billing_month']: billingYearValue + billingMonthValue};
        }
        if (this.props.searchresults.daterangeoption.value) {
            objArr = {
                ...objArr,
                ['lead_create_start']: this.convert(this.props.searchresults.startDate),
            };
            objArr = {
                ...objArr,
                ['lead_create_end']: this.convert(this.props.searchresults.endDate),
            };
        }
        if (mediumVal.trim() != '') {
            objArr = {...objArr, ['medium']: mediumVal.trim()};
        }
        if (offertypeVal.trim() != '') {
            objArr = {...objArr, ['offer_type']: offertypeVal.trim()};
        }
        let sourceVal = $('.hidden-lbl.source-lbl').text();
        if (sourceVal.trim() != '') {
            objArr = {...objArr, ['source']: sourceVal.trim()};
        }

        if (this.props.searchresults.selectedOption.value == 'unique_student_report') {
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            if (dollarVal.trim() != '') {
                dollarVal = dollarVal.replace(/\$/g, '');
                objArr = {...objArr, ['dollar_cost']: dollarVal.trim()};
            }
        }

        const reportRequestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        };

        fetch(`./wp-json/asd/api/report`, reportRequestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Something went's wrong. Please try again later");
                }
            })
            .then(data => {
                const fileURL = data.data.file_url;
                const url = new URL(fileURL);
                const anchor = document.createElement('a');
                anchor.href = url.pathname;
                anchor.download = fileURL.split('/').pop();
                document.body.appendChild(anchor);
                anchor.click();
                this.setState({
                    islistloading: false,
                    is_email_message: 'Excel report downloaded successfully',
                });
            })
            .catch(error => {
                this.setState({is_email_message: error, islistloading: false});
            });
    };

    emailFile = async e => {
        this.setState({isemailloading: true});
        let offertypeVal = $('.hidden-lbl.offer-type').text();
        let mediumVal = $('.hidden-lbl.medium-lbl').text();
        const get_token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        let billingYearValue = this.props.searchresults.selectMonth.getFullYear();
        let billingMonthValue = ('0' + (this.props.searchresults.selectMonth.getMonth() + 1)).slice(
            -2
        );
        let objArr = {
            report_type: this.props.searchresults.selectedOption.value,
            present_date_range: this.props.searchresults.daterangeoption.value,
        };
        if (this.state.is_email == 1) {
            objArr = {...objArr, ['is_email']: this.state.is_email};
        }
        if (this.state.is_export == 1) {
            objArr = {...objArr, ['is_export']: this.state.is_export};
        }
        if (inpersonateFlag == 'true') {
            objArr = {...objArr, ['view_user_id']: userId};
        }
        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' ||
            this.props.searchresults.selectedOption.value == 'unique_student_report'
        ) {
            objArr = {...objArr, ['billing_month']: billingYearValue + billingMonthValue};
        }
        if (this.props.searchresults.daterangeoption.value) {
            objArr = {
                ...objArr,
                ['lead_create_start']: this.props.searchresults.startDate
                    .toISOString()
                    .split('T')[0],
            };
            objArr = {
                ...objArr,
                ['lead_create_end']: this.props.searchresults.endDate.toISOString().split('T')[0],
            };
        }
        if (mediumVal.trim() != '') {
            objArr = {...objArr, ['medium']: mediumVal.trim()};
        }
        if (offertypeVal.trim() != '') {
            objArr = {...objArr, ['offer_type']: offertypeVal.trim()};
        }
        let sourceVal = $('.hidden-lbl.source-lbl').text();
        if (sourceVal.trim() != '') {
            objArr = {...objArr, ['source']: sourceVal.trim()};
        }

        if (this.props.searchresults.selectedOption.value == 'unique_student_report') {
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            if (dollarVal.trim() != '') {
                dollarVal = dollarVal.replace(/\$/g, '');
                objArr = {...objArr, ['dollar_cost']: dollarVal.trim()};
            }
        }

        const reportRequestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/report`, reportRequestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Something went's wrong. Please try again later");
                }
            })
            .then(data => {
                var message = data.message;
                this.setState({is_email_message: message, isemailloading: false});
            })
            .catch(error => {
                this.setState({is_email_message: error, isemailloading: false});
            });
    };

    handlePageChange = async page => {
        $('.data-loader').css('display', 'flex');
        let offertypeVal = $('.hidden-lbl.offer-type').text();
        let mediumVal = $('.hidden-lbl.medium-lbl').text();
        const get_token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        let billingYearValue = this.props.searchresults.selectMonth.getFullYear();
        let billingMonthValue = ('0' + (this.props.searchresults.selectMonth.getMonth() + 1)).slice(
            -2
        );
        let tab_active_report;
        if ($('.tabbing-blk').length > 0) {
            tab_active_report = $('.tab-btn.active').text();
        }
        let objArr = {
            report_type: this.props.searchresults.selectedOption.value,
            // 'present_date_range' : this.props.searchresults.daterangeoption.value,
            page_no: page,
        };

        if (this.props.searchresults.daterangeoption.value) {
            objArr = {
                ...objArr,
                ['lead_create_start']: this.props.searchresults.startDate
                    .toISOString()
                    .split('T')[0],
            };
            objArr = {
                ...objArr,
                ['lead_create_end']: this.props.searchresults.endDate.toISOString().split('T')[0],
            };
        }
        if (this.props.searchresults.selectedOption.value != 'credit_lead_return_resason_report') {
            objArr = {
                ...objArr,
                ['present_date_range']: this.props.searchresults.daterangeoption.value,
            };
        }

        if (mediumVal.trim() != '') {
            objArr = {...objArr, ['medium']: mediumVal.trim()};
        }
        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' ||
            this.props.searchresults.selectedOption.value == 'unique_student_report'
        ) {
            objArr = {...objArr, ['tab_type']: tab_active_report};
        }
        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' ||
            this.props.searchresults.selectedOption.value == 'unique_student_report'
        ) {
            objArr = {...objArr, ['billing_month']: billingYearValue + billingMonthValue};
        }
        //  if (inpersonateFlag == 'true'){
        //   objArr = {...objArr, ['view_user_id'] : userId }
        //  }
        if (offertypeVal.trim() != '') {
            objArr = {...objArr, ['offer_type']: offertypeVal.trim()};
        }

        if (this.props.searchresults.selectedOption.value == 'unique_student_report') {
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            if (dollarVal.trim() != '') {
                dollarVal = dollarVal.replace(/\$/g, '');
                objArr = {...objArr, ['dollar_cost']: dollarVal.trim()};
            }
        }

        let sourceVal = $('.hidden-lbl.source-lbl').text();
        if (sourceVal.trim() != '') {
            objArr = {...objArr, ['source']: sourceVal.trim()};
        }

        const reportRequestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/report`, reportRequestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({reportResults: data});
                $('.data-loader').css('display', 'none');
            })
            .catch(error => console.log(error));
    };

    convert = str => {
        var date = new Date(str),
            mnth = ('0' + (date.getMonth() + 1)).slice(-2),
            day = ('0' + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join('/');
    };
    get_reporttab_data = str => {
        var date = new Date(str),
            mnth = ('0' + (date.getMonth() + 1)).slice(-2);
        return [date.getFullYear(), mnth].join('/');
    };

    handleItemClick(index) {
        this.setState({
            activeIndex: index,
            reporttab_index: 1,
            istab_active: true,
            reportResults: '',
        });
        let tab_active_report = $('#tab-btn_' + index).text();
        const get_token = localStorage.getItem('token');
        let billingYearValue = this.props.searchresults.selectMonth.getFullYear();
        let billingMonthValue = ('0' + (this.props.searchresults.selectMonth.getMonth() + 1)).slice(
            -2
        );
        let objArr = {
            report_type: this.props.searchresults.selectedOption.value,
            tab_type: tab_active_report,
            page_no: this.props.searchresults.page,
            //  'billing_month': "202012"
        };
        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' ||
            this.props.searchresults.selectedOption.value == 'unique_student_report'
        ) {
            objArr = {...objArr, ['billing_month']: billingYearValue + billingMonthValue};
        }
        let sourceVal = $('.hidden-lbl.source-lbl').text();
        if (sourceVal.trim() != '') {
            objArr = {...objArr, ['source']: sourceVal.trim()};
        }

        if (this.props.searchresults.selectedOption.value == 'unique_student_report') {
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            if (dollarVal.trim() != '') {
                dollarVal = dollarVal.replace(/\$/g, '');
                objArr = {...objArr, ['dollar_cost']: dollarVal.trim()};
            }
        }

        if (
            this.props.searchresults.selectedOption.value == 'credit_lead_return_resason_report' &&
            this.props.searchresults.leadReturnReason.length > 0
        ) {
            objArr = {
                ...objArr,
                ['lead_return_reason']: this.props.searchresults.leadReturnReason
                    .map(reason => reason.value)
                    .join('¤'),
            };
        }

        const reportRequestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/report`, reportRequestOptions)
            .then(response => response.json())
            .then(data => {
                var message = data.message;
                this.setState({tab_reportResults: data, istab_active: false});
            })
            .catch(function (response) {
                console.log(response);
                console.log("Something Went's wrong");
            });
    }

    renderResults = () => {
        console.log(this.props.searchresults);
        if (this.props.searchresults.reportresults.keys != null) {
            console.log('test');
            columns = this.props.searchresults.reportresults.keys.map(elem => ({
                name: elem.replace(/([A-Z]+)/g, ' $1').trim(),
                selector: elem,
            }));
        }

        if (this.state.tab_reportResults.keys != null) {
            console.log(this.state.tab_reportResults.keys);
            tabcolumns = this.state.tab_reportResults.keys.map(elem => ({
                name: elem.replace(/([A-Z]+)/g, ' $1').trim(),
                selector: elem,
            }));
            console.log(tabcolumns);
        }
        if (this.state.reportResults.keys != null) {
            console.log('test2');
            tabpagecolumns = this.state.reportResults.keys.map(elem => ({
                name: elem.replace(/([A-Z]+)/g, ' $1').trim(),
                selector: elem,
            }));
        }

        return (
            <div className="report-datatable">
                {this.props.searchresults.loading ? (
                    <div className="filter-collapse loader-div">
                        <div className="spinner"></div>
                        {this.props.searchresults.responsemessage}
                    </div>
                ) : (
                    <div>
                        <div className="filter-collapse selectvalue-filter">
                            <div
                                className={
                                    this.state.selectValue ? 'Collapsible' : 'Collapsible closed'
                                }
                                onClick={e => this.togglePanelSelectValue(e)}
                            >
                                <span className="Collapsible__trigger">Selected Value</span>
                                <span className="arrowimage">{arrowdown}</span>
                            </div>
                            <div
                                className={
                                    this.state.selectValue
                                        ? 'filteroptions-blk filter-active'
                                        : 'filteroptions-blk'
                                }
                            >
                                <div className="filteroptions-row">
                                    {this.props.searchresults.selectedOption.value !=
                                        'credit_lead_return_resason_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'unique_student_report' ? (
                                        <div className="col-3">
                                            <label>Present Date Range</label>
                                            <label className="select-valu-lbl">
                                                {this.props.searchresults.daterangeoption.value}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {this.props.searchresults.selectedOption.value !=
                                        'credit_lead_return_resason_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'unique_student_report' ? (
                                        <div className="col-3">
                                            <label>Medium</label>
                                            <label className="select-valu-lbl">
                                                {this.props.searchresults.medium.length != 0
                                                    ? this.props.searchresults.medium.map(o => (
                                                          <span>{o.value}</span>
                                                      ))
                                                    : 'All'}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className="filteroptions-row">
                                    {this.props.searchresults.selectedOption.value !=
                                        'credit_lead_return_resason_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'intraday_linkout_lead_detail_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'interaday_external_partner_lead_detailed_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'unique_student_report' ? (
                                        <div className="col-3 custom-date-lbl " id="date-div">
                                            <label>Lead Create Start Date</label>
                                            <label className="select-valu-lbl">
                                                {this.convert(this.props.searchresults.startDate)}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div className="col-3">
                                        <label>Provider</label>
                                        {/* <label className="select-valu-lbl"> {this.props.searchresults.source_Provider}</label> */}
                                        <label className="select-valu-lbl">
                                            {this.props.searchresults.sourceList.length != 0
                                                ? this.props.searchresults.sourceList.map(o => (
                                                      <span>{o.value}</span>
                                                  ))
                                                : 'All'}
                                        </label>
                                    </div>
                                    {this.props.searchresults.selectedOption.value ==
                                    'unique_student_report' ? (
                                        <div className="col-3">
                                            <label>Dollar Cost</label>
                                            <label className="select-valu-lbl">
                                                {this.props.searchresults.dollarCost.length != 0
                                                    ? this.props.searchresults.dollarCost.map(o => (
                                                          <span>{o.value}</span>
                                                      ))
                                                    : 'All'}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className="filteroptions-row">
                                    {this.props.searchresults.selectedOption.value ==
                                        'credit_lead_return_resason_report' ||
                                    this.props.searchresults.selectedOption.value ==
                                        'unique_student_report' ? (
                                        <div className="col-3">
                                            <label>Month</label>
                                            <label className="select-valu-lbl">
                                                {this.get_reporttab_data(
                                                    this.props.searchresults.selectMonth
                                                )}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className="filteroptions-row">
                                    {this.props.searchresults.selectedOption.value !=
                                        'credit_lead_return_resason_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'intraday_linkout_lead_detail_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'interaday_external_partner_lead_detailed_report' &&
                                    this.props.searchresults.selectedOption.value !=
                                        'unique_student_report' ? (
                                        <div className="col-3 custom-date-lbl">
                                            <label>Lead Create End Date</label>
                                            <label className="select-valu-lbl">
                                                {this.convert(this.props.searchresults.endDate)}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {this.props.searchresults.selectedOption.value ==
                                        'external_partner_lead_detailed_report' ||
                                    this.props.searchresults.selectedOption.value ==
                                        'interaday_external_partner_lead_detailed_report' ? (
                                        <div className="col-3">
                                            <label>Offer Type</label>
                                            <label className="select-valu-lbl">
                                                {this.props.searchresults.offerType.length != 0
                                                    ? this.props.searchresults.offerType.map(o => (
                                                          <span>{o.value}</span>
                                                      ))
                                                    : 'All'}
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>

                                <div className="filteroptions-row">
                                    <div className="col-3">
                                        <label>Ran on</label>
                                        <label className="select-valu-lbl">
                                            {this.state.tab_reportResults.ran_on
                                                ? this.state.tab_reportResults.ran_on
                                                : this.props.searchresults.reportresults.ran_on}
                                        </label>
                                    </div>
                                    <div className="col-3">
                                        <label>Vendor</label>
                                        <label className="select-valu-lbl">
                                            {' '}
                                            {this.props.searchresults.source_Provider}
                                        </label>
                                    </div>
                                    {/* {this.props.searchresults.selectedOption.value == 'interaday_external_partner_lead_detailed_report' ?
                                            <div className="col-3">
                                                <label>Site</label>
                                                <label className="select-valu-lbl"> {this.props.searchresults.sites != null ?  (this.props.searchresults.sites.map(o => <span>{o.value}</span> )) : ''} </label>
                                                                    
                                            </div>
                                    : ''}                              */}
                                </div>
                                <div className="filteroptions-row">
                                    <div className="col-3">
                                        <label>Total Record Count</label>
                                        <label className="select-valu-lbl">
                                            {this.state.tab_reportResults.total_records
                                                ? this.state.tab_reportResults.total_records
                                                : this.props.searchresults.reportresults
                                                      .total_records}
                                        </label>
                                        <label></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filter-collapse searchReport ">
                            <div
                                className={
                                    this.state.searchRport ? 'Collapsible' : 'Collapsible closed'
                                }
                                onClick={e => this.togglePanelsearchReport(e)}
                            >
                                <span className="Collapsible__trigger">Report Data</span>
                                <span className="arrowimage">{arrowdown}</span>
                            </div>
                            {this.props.searchresults.reportresults.total_records > 0 ? (
                                <div className="report-actions">
                                    <label>Actions: </label>
                                    <span>
                                        <button
                                            onClick={this.emailFile}
                                            title="Send Email"
                                            className="tooltip"
                                        >
                                            <i className="fa fa-envelope" />
                                        </button>
                                        <button
                                            onClick={this.exportFile}
                                            title="Export File"
                                            className="tooltip"
                                        >
                                            <i className="fa fa-floppy-o" />
                                        </button>
                                    </span>
                                </div>
                            ) : (
                                ''
                            )}
                            {this.state.isemailloading ? (
                                <div className="list-download-loader">
                                    <div className="spinner"></div>
                                </div>
                            ) : (
                                ''
                            )}
                            {this.state.is_email_message.length > 0 ? (
                                <p className="email-sent-msg">{this.state.is_email_message}</p>
                            ) : (
                                ''
                            )}
                            {this.state.islistloading ? (
                                <div className="list-download-loader">
                                    <div className="spinner"></div>
                                    <p>Wait for Moment File is in process</p>
                                </div>
                            ) : (
                                ''
                            )}
                            {this.props.searchresults.selectedOption.value !=
                                'credit_lead_return_resason_report' &&
                            this.props.searchresults.selectedOption.value !=
                                'unique_student_report' ? (
                                <div
                                    className={
                                        this.state.searchRport
                                            ? 'filteroptions-blk filter-active'
                                            : 'filteroptions-blk'
                                    }
                                >
                                    <div className="data-loader">
                                        <div className="spinner"></div>
                                    </div>
                                    {Object.keys(this.state.reportResults).length ||
                                    this.state.reportResults.length > 0 ? (
                                        <DataTable
                                            columns={columns}
                                            className={
                                                'report-data ' +
                                                this.props.searchresults.selectedOption.value
                                            }
                                            data={this.state.reportResults.data}
                                            highlightOnHover
                                            pagination={true}
                                            paginationServer={true}
                                            paginationTotalRows={
                                                this.props.searchresults.reportresults.total_records
                                            }
                                            paginationPerPage={50}
                                            paginationDefaultPage={2}
                                            fixedHeader={true}
                                            paginationComponentOptions={{
                                                noRowsPerPage: true,
                                            }}
                                            onChangePage={this.handlePageChange}
                                        />
                                    ) : (
                                        <div>
                                            <DataTable
                                                className={
                                                    'report-data ' +
                                                    this.props.searchresults.selectedOption.value
                                                }
                                                columns={columns}
                                                data={this.props.searchresults.reportresults.data}
                                                highlightOnHover
                                                pagination={true}
                                                fixedHeader={true}
                                                fixedHeaderScrollHeight="400px"
                                                paginationServer={true}
                                                paginationTotalRows={
                                                    this.props.searchresults.reportresults
                                                        .total_records
                                                }
                                                paginationPerPage={50}
                                                paginationComponentOptions={{
                                                    noRowsPerPage: true,
                                                }}
                                                onChangePage={this.handlePageChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div
                                    className={
                                        this.state.searchRport
                                            ? 'filteroptions-blk filter-active'
                                            : 'filteroptions-blk'
                                    }
                                >
                                    <div className="tabbing-blk">
                                        {tabData.map((btn, i) => (
                                            <>
                                                {btn.name == 'Return Reason' &&
                                                this.props.searchresults.selectedOption.value ===
                                                    'unique_student_report' ? (
                                                    ''
                                                ) : (
                                                    <button
                                                        key={i}
                                                        id={'tab-btn_' + i}
                                                        className={
                                                            this.state.activeIndex === i
                                                                ? 'tab-btn active'
                                                                : 'tab-btn'
                                                        }
                                                        onClick={this.handleItemClick.bind(this, i)}
                                                        text={btn.name}
                                                    >
                                                        {btn.name}
                                                    </button>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                    {this.state.istab_active ? (
                                        <div className="filter-collapse loader-div">
                                            <div className="spinner"></div>
                                        </div>
                                    ) : (
                                        <div>
                                            {this.state.reporttab_index == 0 ? (
                                                <div>
                                                    {Object.keys(this.state.reportResults).length ||
                                                    this.state.reportResults.length > 0 ? (
                                                        <DataTable
                                                            columns={columns}
                                                            className={
                                                                'report-data ' +
                                                                this.props.searchresults
                                                                    .selectedOption.value
                                                            }
                                                            data={this.state.reportResults.data}
                                                            highlightOnHover
                                                            pagination={true}
                                                            paginationServer={true}
                                                            paginationTotalRows={
                                                                this.props.searchresults
                                                                    .reportresults.total_records
                                                            }
                                                            paginationPerPage={50}
                                                            paginationDefaultPage={2}
                                                            fixedHeader={true}
                                                            paginationComponentOptions={{
                                                                noRowsPerPage: true,
                                                            }}
                                                            onChangePage={this.handlePageChange}
                                                        />
                                                    ) : (
                                                        <div>
                                                            <DataTable
                                                                columns={columns}
                                                                className={
                                                                    'report-data ' +
                                                                    this.props.searchresults
                                                                        .selectedOption.value
                                                                }
                                                                data={
                                                                    this.props.searchresults
                                                                        .reportresults.data
                                                                }
                                                                highlightOnHover
                                                                pagination={true}
                                                                fixedHeader={true}
                                                                paginationServer={true}
                                                                paginationTotalRows={
                                                                    this.props.searchresults
                                                                        .reportresults.total_records
                                                                }
                                                                paginationPerPage={50}
                                                                paginationComponentOptions={{
                                                                    noRowsPerPage: true,
                                                                }}
                                                                onChangePage={this.handlePageChange}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="data-loader">
                                                        <div className="spinner"></div>
                                                    </div>
                                                    {Object.keys(this.state.reportResults).length ||
                                                    this.state.reportResults.length > 0 ? (
                                                        <DataTable
                                                            columns={tabpagecolumns}
                                                            className={
                                                                'report-data ' +
                                                                this.props.searchresults
                                                                    .selectedOption.value
                                                            }
                                                            data={this.state.reportResults.data}
                                                            highlightOnHover
                                                            pagination={true}
                                                            paginationServer={true}
                                                            paginationTotalRows={
                                                                this.state.reportResults
                                                                    .total_records
                                                            }
                                                            paginationPerPage={50}
                                                            paginationDefaultPage={2}
                                                            fixedHeader={true}
                                                            paginationComponentOptions={{
                                                                noRowsPerPage: true,
                                                            }}
                                                            onChangePage={this.handlePageChange}
                                                        />
                                                    ) : (
                                                        <DataTable
                                                            columns={tabcolumns}
                                                            className={
                                                                'report-data ' +
                                                                this.props.searchresults
                                                                    .selectedOption.value
                                                            }
                                                            data={this.state.tab_reportResults.data}
                                                            highlightOnHover
                                                            pagination={true}
                                                            fixedHeader={true}
                                                            paginationServer={true}
                                                            paginationTotalRows={
                                                                this.state.tab_reportResults
                                                                    .total_records
                                                            }
                                                            paginationPerPage={50}
                                                            paginationComponentOptions={{
                                                                noRowsPerPage: true,
                                                            }}
                                                            onChangePage={this.handlePageChange}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    componentDidMount() {
        // if (!this.props.searchresults.open) {
        //   console.log(this.props.searchresults.open);
        //   this.setState({ selectValue: this.state.selectValue, searchRport: this.state.searchRport });
        //   // $(".report-actions").addClass("hide");
        // }
        // else {
        //   console.log("false");
        //   console.log(this.state.selectValue);
        //   this.setState({ selectValue: this.state.selectValue, searchRport: this.state.searchRport });
        // }
    }

    componentDidUpdate(prevProps) {
        if (this.state.is_email_message.length > 0) {
            setTimeout(() => this.setState({is_email_message: ''}), 5000);
        }

        if ($('.report-data').length > 0) {
            let el = document.querySelector('.rdt_Table');
            let x = 0,
                y = 0,
                top = 0,
                left = 0;

            let draggingFunction = e => {
                document.addEventListener('mouseup', () => {
                    document.removeEventListener('mousemove', draggingFunction);
                });

                el.scrollLeft = left - e.pageX + x;
                el.scrollTop = top - e.pageY + y;
            };

            el.addEventListener('mousedown', e => {
                e.preventDefault();

                y = e.pageY;
                x = e.pageX;
                top = el.scrollTop;
                left = el.scrollLeft;

                document.addEventListener('mousemove', draggingFunction);
            });
        }
    }

    componentWillReceiveProps() {
        this.setState({
            selectedOption: this.props.searchresults.selectedOption,
            sourceProvider: this.props.searchresults.sourceProvider,
            daterangeoption: this.props.searchresults.daterangeoption,
            reportresults: this.props.searchresults.reportresults,
            loading: this.props.searchresults.loading,
        });
        this.setState({reportResults: '', page: 1, reporttab_index: 0, activeIndex: 0});
    }

    render() {
        return <div className="">{this.renderResults()}</div>;
    }
}

export default SearchReports;
